<div class="profile-details">
  <p class="photo-label">Logo</p>
  <div class="profile-photo-section">
    
    <div class="photo-container">
      <img *ngIf="logoUrl && !isImageUploading" [src]="logoUrl" alt="Business Logo" class="business-logo" />
      <span *ngIf="!logoUrl && !isImageUploading" class="initials">{{ initials }}</span>
      
      <!-- Spinner loader during image upload -->
      <div *ngIf="isImageUploading" class="upload-spinner">
        <div class="spinner"></div>
      </div>
    </div>
    <div class="photo-info">
      
      <p class="photo-guidelines">
        Maximum image size: 20MB<br /> Supported format: JPG or PNG <br/> Best results: 500px
      </p>
      <div class="photo-buttons">
        <button class="upload-button" type="button"  [disabled]=" isImageUploading" (click)="fileInput.click()">
          {{ logoUrl ? 'Change photo' : 'Upload Logo' }}
        </button>
        <!-- based figma text changed from change logo to change photo -->
        <!-- <button class="remove-button" *ngIf="logoUrl" [style.pointer-events]="!isEditing ? 'none' : 'auto'" type="button" [disabled]="isImageUploading" (click)="removePhoto()">
          Remove Logo
        </button> -->
      </div>
      <div *ngIf="uploadError" class="error-message upload-error">
        {{ uploadError }}
      </div>
      <input hidden #fileInput type="file" (change)="onFileSelected($event)" accept="image/png, image/jpeg, image/jpg">
    </div>
  </div>
  <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="profile-form" >
    <div class="form-row-single">
      <div class="form-group">
        <label for="businessName">Business Name<span class="required">*</span></label>
        <input type="text" class="form-control" id="businessName" formControlName="businessName" maxlength="100" />
        <div *ngIf="businessName?.invalid && (businessName?.dirty || businessName?.touched)" class="error-message">
          <div *ngIf="businessName?.errors?.['required']">
            Business name is required.
          </div>
          <div *ngIf="businessName?.errors?.['standardName']">
            {{ businessName?.errors?.['standardName']?.message }}
          </div>
          <div *ngIf="businessName?.errors?.['maxlength']">
            Business name cannot exceed 100 characters.
          </div>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <label for="email">Email<span class="required">*</span></label>
        <input type="email" class="form-control" id="email" formControlName="email" maxlength="254" />
        <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="error-message">
          <div *ngIf="email?.errors?.['required']">
            Email is required.
          </div>
          <div *ngIf="email?.errors?.['strictEmail']">
            Please enter a valid email address.
          </div>
          <div *ngIf="email?.errors?.['maxlength']">
            Email cannot exceed 254 characters.
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="phoneNumber">Phone Number<span class="required">*</span></label>
        <input type="tel" class="form-control" id="phoneNumber" formControlName="phoneNumber" maxlength="15" />
        <div *ngIf="phoneNumber?.invalid && (phoneNumber?.dirty || phoneNumber?.touched)" class="error-message">
          <div *ngIf="phoneNumber?.errors?.['required']">
            Phone number is required.
          </div>
          <div *ngIf="phoneNumber?.errors?.['usaPhone']">
            Please enter a valid phone number.
          </div>
          <div *ngIf="phoneNumber?.errors?.['maxlength']">
            Phone number cannot exceed 15 characters.
          </div>
        </div>
      </div>
    </div>
    <div class="form-actions" >
      <!-- <button type="button" class="btn btn-secondary btn-medium" (click)="onCancel()">Cancel</button> -->
      <button type="submit" class="btn btn-primary btn-medium" [ngClass]="{'disabled': profileForm.invalid || !isFormModified || isSubmitting}" [disabled]="profileForm.invalid || !isFormModified || isSubmitting">
        <span *ngIf="!isSubmitting">Save</span>
        <span *ngIf="isSubmitting" class="saving-content">
          <div class="spinner-small"></div>
          Saving...
        </span>
      </button>
    </div>
  </form>
</div> 